export default __webpack_public_path__ + "eba1c13c5170e4019e5a73c592a6df93.svg";